import { ErpProductsInterface } from 'src/modules/erpProducts/types/ErpProductsInterface';

export function hasProductsInventory(product: ErpProductsInterface) {
  if (product.pro_estoqueatual > 0) {
    return true;
  }

  return false;
}
